import { getData } from 'services/api';
import { Highlights } from './types';

export const fetchAllHighlights = (): Promise<Highlights<string>> => getData('/events/highlights?date=all&per_page=-1');
export const fetchEventHighlights = (id?: string): Promise<Highlights<string>> =>
	getData(`events/${id}/highlights?per_page=-1`);
